import cx from 'classnames'
import { memo } from 'react'
import { useWindowSize } from '@/hooks/useWindowSize'
import { Emoji, Input, Text } from '@/components/ui'
import s from './style.module.scss'
import { MEDIATEKA_DOWNLOAD } from '@/constants/urls'

interface ISelectionControlsProps {
  type: string
  answer?: any
  onChange: (text: string | null) => void
  checked: boolean
  value?: any
  freeForm?: boolean
}

const SelectionControls = ({ type, answer, onChange, checked, value, freeForm }: ISelectionControlsProps) => {
  const { deviceWidth } = useWindowSize()

  const inputWrapperClassList = cx(s['input-wrapper'], s[type], {
    [s.active]: checked
  })

  return (
    <label className={inputWrapperClassList}>
      <div className={s['input-container']}>
        <input type='checkbox' className={s.input} value='' onChange={() => onChange(null)} checked={checked} />
        <div className={s.checkmark} />
        <div className={s.content}>
          <div className={s.content__text}>
            {answer?.image_id && (
              <img
                src={`${MEDIATEKA_DOWNLOAD}/${answer.image_id}`}
                alt='Изображение объекта ранжирования'
                className={s.image}
                style={{ maxHeight: 240 }}
              />
            )}
            {answer?.title && <Text>{answer?.title}</Text>}
          </div>
          {answer?.smile && (
            <Emoji name={answer.smile} size={deviceWidth === 'large' ? 'lg' : 'md'} style={{ marginLeft: 3 }} />
          )}
          {freeForm && (
            <Input
              name='free_form_answer'
              className={s['free-form-answer-input']}
              fluid
              value={value}
              placeholder='Введите свой вариант ответа (Не более 500 символов)'
              onChange={(text) => onChange(text.target.value)}
            />
          )}
        </div>
      </div>
    </label>
  )
}

export default memo(SelectionControls)
